import React from "react";
import { GlobalContainer } from "../../Global/layout";
import { LineHeading } from "../../LineHeading";
import { StyledHeadingh1 } from "../../Global/headings";
import { ImageContainer, LineComponent, StyledParagraph } from "./style";
import { BlackButtonLink } from "../../Global/button";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/bundle";
import "swiper/css";

const PhaseEBookFeaturedWork = ({ data, sectionCount }: any) => {
  return (
    <section className="light">
      <GlobalContainer>
        <LineHeading title={data?.lineHeading} number={sectionCount} />
        <StyledHeadingh1 maxWidth="800px" text={data?.heading} />
        {data?.content && (
          <StyledParagraph
            data-aos="fade-up"
            dangerouslySetInnerHTML={{ __html: data?.content }}
          />
        )}
        <BlackButtonLink
          data-aos="fade-up"
          to="/our-work"
          style={{ marginTop: "48px" }}
        >
          View All
        </BlackButtonLink>
      </GlobalContainer>
      <ImageContainer data-aos="fade-up">
        <Swiper
          slidesPerView={"auto"}
          spaceBetween={16}
          breakpoints={{
            320: {
              spaceBetween: 16,
            },
            640: {
              spaceBetween: 20,
            },
            768: {
              spaceBetween: 30,
            },
            1024: {
              spaceBetween: 48,
            },
          }}
        >
          {data?.featuredWorks?.map((item: any, index: number) => {
            const url = item.slug ? `/our-work/${item.slug}/` : item.link;
            return (
              <SwiperSlide key={index}>
                <a href={url}>
                  <div className="blog_img">
                    <img src={item.featuredImage?.node?.mediaItemUrl} alt={item.featuredImage?.node?.altText} />
                  </div>
                  <div>
                    <LineComponent>
                      <span>{item.title}</span>
                      <span className="category-name-mobile">
                        0{index + 1}/0{item?.length}
                      </span>
                      <span className="category-name-desktop">
                        {item.caseStudyCategories?.nodes[0]?.name}
                      </span>
                    </LineComponent>
                  </div>
                </a>
              </SwiperSlide>
            );
          })}
        </Swiper>
      </ImageContainer>
    </section>
  );
};

export default PhaseEBookFeaturedWork;
